import {urlBase64Decode} from "../utils/utils";

export class Token {

    constructor(private token) {
    }

    /**
     * Obtiene el token
     * @returns {boolean}
     */
    getToken(): string {
        return this.token;
    }

    /**
     * Is data expired
     * @returns {boolean}
     */
    isValid(): boolean {
        try {
            return this.token && (!this.getTokenExpDate() || (new Date()).getTime() < this.getTokenExpDate().getTime());
        } catch (e) {
            return false;
        }
    }

    /**
     * Obtiene la fecha de expiración
     * @returns Date
     */
    getTokenExpDate(): Date {
        const decoded = this.getPayload();

        if (!decoded) {
            throw new Error("El token " + this.token + " no es valid, no puede ser decodificado.");
        }

        if (!decoded.hasOwnProperty('exp')) {
            return null;
        }

        return new Date(decoded.exp);
    }

    /**
     * Devuelve el objeto payload
     * @returns any
     */
    getPayload(): any {

        const parts = this.token.split('.');

        if (parts.length !== 3) {
            return null;
        }

        let decoded;
        try {
            decoded = urlBase64Decode(parts[1]);
        } catch (e) {
            return null;
        }

        if (!decoded) {
            return null;
        }

        return JSON.parse(decoded);
    }

}


// WEBPACK FOOTER //
// ./src/app/core/models/token.ts